import CoffeeICon from "../../../../icons/coffeeIcon";
import FileIcon from "../../../../icons/fileIcon";
import LoginIcon from "../../../../icons/loginIcon";
import LogoutIcon from "../../../../icons/logoutIcon";

const AttendanceAndVacation = ({ t }) => {
  const record = [
    {
      date: "الخميس، ٢5 أبريل 2025",
      attendance: "9:30 صباحا",
      leave: "5:30 مساء",
    },
    {
      date: "الخميس، ٢5 أبريل 2025",
      attendance: "9:30 صباحا",
      leave: "5:30 مساء",
    },
    {
      date: "الخميس، ٢5 أبريل 2025",
      attendance: "9:30 صباحا",
      leave: "5:30 مساء",
    },
    {
      date: "الخميس، ٢5 أبريل 2025",
      attendance: "9:30 صباحا",
      leave: "5:30 مساء",
    },
  ];
  return (
    <div>
      <section className="bg-[#182443] p-8 rounded-lg space-y-4">
        <h3 className="text-lg font-bold">{t("attendanceAndVacations")}</h3>
        <div className="flex flex-wrap items-center gap-4 md:flex-nowrap">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="font-bold text-primary">{t("monthlyAttendance")}:</p>
              <p className="mt-2 text-xl font-semibold">19 {t("day")}</p>
            </div>
            <div className="w-2/3">
              <span className="grid mx-auto place-content-center size-14 border-[6px] border-[#31CD9E] border-b-transparent rounded-full">
                98%
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="font-bold text-primary">{t("absenceDays")}:</p>
              <p className="mt-2 text-xl font-semibold">1 {t("day")}</p>
            </div>
            <div className="w-2/3">
              <span className="grid mx-auto place-content-center size-14 border-[6px] border-[#CF4242] border-b-transparent rounded-full">
                2%
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-4 md:flex-nowrap">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="font-bold text-primary">{t("annualLeaveBalance")}:</p>
              <p className="mt-2 text-xl font-semibold">15 {t("day")}</p>
            </div>
            <div className="w-2/3">
              <CoffeeICon className={"mx-auto"} />
            </div>
          </div>
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="font-bold text-primary">{t("consumed")}:</p>
              <p className="mt-2 text-xl font-semibold">5 {t("day")}</p>
            </div>
            <div className="w-2/3">
              <span className="grid mx-auto place-content-center size-14 border-[6px] border-[#3872FA] border-b-transparent rounded-full">
                30%
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between w-full gap-4 md:w-1/2">
          <div>
            <p className="font-bold text-primary">{t("remaining")}:</p>
            <p className="mt-2 text-xl font-semibold">10 {t("day")}</p>
          </div>
          <div className="w-2/3">
            <span className="grid mx-auto place-content-center size-14 border-[6px] border-[#F59E0B] border-b-transparent rounded-full">
              70%
            </span>
          </div>
        </div>
      </section>
      <section className="bg-[#182443] p-8 rounded-lg space-y-4 mt-4">
        <h3 className="text-lg font-bold">{t("dailyAttendanceRecord")}</h3>
        <div className="grid grid-cols-2 gap-4">
          {record.map((r, i) => {
            return (
              <div key={i} className="p-3 space-y-3 border rounded-lg border-primary">
                <div className="flex items-center gap-2">
                  <span className="grid place-content-center rounded-full size-6 bg-[#F1F3F8]">
                    <FileIcon />
                  </span>
                  <span className="font-semibold">{r.date}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <span className="grid place-content-center size-8 bg-[#1b2b42] rounded-full">
                      <LoginIcon />
                    </span>
                    {r.attendance}
                  </span>
                  <span className="flex items-center gap-2">
                    <span className="grid place-content-center size-8 bg-[#212442] rounded-full">
                      <LogoutIcon />
                    </span>
                    {r.leave}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default AttendanceAndVacation;
